import React, {
  useCallback,
  useEffect, useMemo, useRef, useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import cn from 'classnames'
import * as Yup from 'yup'
import { Form, Formik } from 'formik'

import {
  resetAuth, setBackError, setRegisterSuccess, setStep,
} from '@src/store/ducks/auth/reducer'
import { AppDispatch } from '@src/store/store'
import style from '@src/pages/ActivationCard/ActivationCard.module.scss'
import { Button } from '@src/components/Button/Button'
import { Title } from '@src/components/Title/Title'
import { ActivationCardForm } from '@src/pages/ActivationCard/ActivationCardForm'
import { ActivationPhoneCodeForm } from '@src/pages/ActivationCard/ActivationPhoneCodeForm'
import { RegistrationForm } from '@src/pages/Registration/RegistrationForm'
import { QuestionaryForm } from '@src/pages/ActivationCard/QuestionaryForm'
import {
  selectAuthSuccessRegistration, selectBackError, selectIsLoading, selectStep,
} from '@src/store/ducks/auth/selectors'
import { birthday, phoneRegexp } from '@src/lib/regex'
import { validateForm } from '@src/messages/validateForm'
import { finalRegistrationCard } from '@src/store/ducks/auth/thunks'
import { Modal } from '@src/components/Modal/Modal'
import { selectIsAuth } from '@src/store/ducks/app/selectors'

/* const genderArr = [
  { id: 0, title: 'мужской', value: 1 },
  { id: 1, title: 'женский', value: 0 },
] */

export const ActivationCard = () => {
  const dispatch = useDispatch<AppDispatch>()
  const regSuccess = useSelector(selectAuthSuccessRegistration)
  const isAuth = useSelector(selectIsAuth)
  const step = useSelector(selectStep)
  const [choice, setChoice] = useState('card')
  const backError = useSelector(selectBackError)
  const isLoading = useSelector(selectIsLoading)
  const formRef = useRef<any>()
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuth) {
      navigate('/lk/points/')
    }
  }, [dispatch, isAuth, navigate, regSuccess])

  useEffect(() => () => {
    dispatch(resetAuth())
    dispatch(setBackError(''))
  }, [dispatch])

  useEffect(() => {
    if (choice === 'card') {
      formRef.current.setFieldValue('choice', 'card')
    } else {
      formRef.current.setFieldValue('choice', 'noCard')
    }
  }, [choice])

  const changeStep = (value: string) => {
    setChoice(value)
    dispatch(setStep(1))
  }
  const resetMyChoice = () => {
    dispatch(setStep(0))
    dispatch(setBackError(''))
    setChoice('')
    formRef.current.resetForm()
  }

  const closeModal = useCallback(() => {
    dispatch(setRegisterSuccess(false))
  }, [dispatch])

  const validationSchema = useMemo(() => (
    Yup.object().shape({
      // cardNumber: Yup.string()
      //   .when('choice', {
      //     is: 'card',
      //     then: Yup.string().matches(card2, validateForm.bonusCard2).required(validateForm.required),
      //     otherwise: Yup.string().notRequired(),
      //   }),
      password: Yup.string().required(validateForm.required)
        .min(8, 'Минимальная длина строки 8 символов'),
      confirmPassword: Yup.string().required(validateForm.required)
        .oneOf([Yup.ref('password'), null], 'Пароли не совпадают'),
    })
  ), [])

  const validationSchema2 = useMemo(() => (
    Yup.object().shape({
      name: Yup.string().required(validateForm.required).max(50, 'Максимально количество символов 50'),
      surname: Yup.string().required(validateForm.required).max(50, 'Максимально количество символов 50'),
      // email: Yup.string().email('Введите корректный адрес эл. почты').matches(email, validateForm.email),
      //  address: Yup.string().required(validateForm.required),
      phone: Yup.string().matches(phoneRegexp, validateForm.phone).required(validateForm.required),
      //  gender: Yup.string().required(validateForm.required),
      birthDate: Yup.string().matches(birthday, validateForm.birthday).required(validateForm.birthday),
    })
  ), [])

  const initialValues = useMemo(() => ({
    choice,
    name: '',
    surname: '',
    patronymic: '',
    cardNumber: '',
    gender: '',
    birthDate: '',
    address: '',
    email: '',
    phone: '',
    code: '',
    password: '',
    confirmPassword: '',
    isProcessingPersonalData: false,
    isAcknowledgedPersonalDataPolicy: false,
    isLoyalty: false,
    isPromotionalMail: false,
    isPoll: false,
    isPromotionalGames: false,
  }), [])

  return (
    <div className={cn(style.activation)}>
      <div className={style.activation__body}>
        <div className={style.tabList}>
          <NavLink end className={style.btnSize} to="/lk/login">
            <Button className={style.menuBtnSize}>Авторизация</Button>
          </NavLink>
          <NavLink end className={style.btnSize} to="/lk/activation">
            <Button onClickFunc={() => resetMyChoice()} className={cn(style.active, style.menuBtnSize)}>Регистрация</Button>
          </NavLink>
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={(
            values,
          ) => {
            dispatch(finalRegistrationCard(
              values.code,
              values.password,
              values.isProcessingPersonalData,
              values.isAcknowledgedPersonalDataPolicy,
              values.isLoyalty,
              values.isPromotionalMail,
              values.isPoll,
              values.isPromotionalGames,
              values.phone,
              values.name,
              values.surname,
              values.patronymic,
              // values.gender,
              values.birthDate,
              // values.email,
              // values.address,
              values.cardNumber,
            ))
          }}
          innerRef={formRef}
          validationSchema={step === 4 ? validationSchema : validationSchema2}
        >
          {({ setFieldValue }) => (
            <Form>
              {step === 0
                && (
                  <div className={style.blockButton}>
                    <div className={style.activationTitle}>
                      У вас уже есть наша
                      {' '}
                      <span className={style.greenColor}>карта лояльности «Дионис»</span>
                      ?
                    </div>
                    <div className={style.imageMain}>
                      <img src="/frontend/images/mainCard.png" alt="card" />
                    </div>
                    <div className={style.box}>
                      <Button
                        type="secondary"
                        className={style.styleBtn}
                        onClickFunc={() => {
                          changeStep('card')
                        }}
                      >
                        Да, у меня есть карта
                      </Button>
                      <Button type="primary" className={cn(style.styleBtn, style.styleBtnPrimary)} onClickFunc={() => changeStep('noCard')}>
                        Нет, хочу
                        электронную карту
                      </Button>
                    </div>
                  </div>
                )}
              {
                choice === 'card' && (
                  <>
                    <div className={style.title}>
                      {
                        (step === 2) && <Title className={style.titleSize} greenTitle="Активация" title="карты" />
                      }
                      {
                        (step === 3) && <Title className={style.titleSize} greenTitle="Заполните" title="анкету" />
                      }
                    </div>
                    {step === 1 && <ActivationCardForm />}
                    {step === 2
                      && (
                        <QuestionaryForm
                          backError={backError}
                          isLoading={isLoading}
                          // etDate={setFieldValue}
                          // genderArr={genderArr}
                        />
                      )}
                    {step === 3 && <ActivationPhoneCodeForm />}
                    {step === 4 && <RegistrationForm setFieldValue={setFieldValue} />}

                  </>
                )
              }
              {choice === 'noCard' && (
                <>
                  {
                    step === (0 || 1)
                    && (
                      <>
                        <Title className={style.titleSize} greenTitle="Заполните" title="анкету" />
                        <QuestionaryForm
                          backError={backError}
                          isLoading={isLoading}
                          // setDate={setFieldValue}
                          // genderArr={genderArr}
                        />
                      </>
                    )
                  }
                  {step === 3 && <ActivationPhoneCodeForm />}
                  {step === 4 && <RegistrationForm setFieldValue={setFieldValue} />}
                </>
              )}
            </Form>
          )}
        </Formik>
      </div>
      <Modal isOpen={regSuccess} close={closeModal}>
        <>
          <div className={style.titleModal}>Пользователь успешно зарегистрирован</div>
        </>
      </Modal>
    </div>
  )
}
